function removeCommentNodes(node) {
  if (!node?.childNodes?.length) {
    return
  }

  Array.from(node.childNodes).forEach((childNode) => {
    if (childNode.nodeType === 8) {
      childNode.parentNode?.removeChild(childNode)
      return
    }

    removeCommentNodes(childNode)
  })
}

export function normalizePastedRichTextHtml(html) {
  const rawHtml = typeof html === 'string' ? html.trim() : ''

  if (!rawHtml || typeof DOMParser === 'undefined') {
    return rawHtml
  }

  try {
    const parsedDocument = new DOMParser().parseFromString(rawHtml, 'text/html')

    parsedDocument
      .querySelectorAll('meta, style, script, link, title, head')
      .forEach((node) => node.remove())

    removeCommentNodes(parsedDocument.body)

    const bodyHtml = parsedDocument.body?.innerHTML?.trim()

    return bodyHtml || rawHtml
  } catch (error) {
    console.warn('Unable to normalize pasted rich text HTML', error)
    return rawHtml
  }
}

export function normalizePastedRichTextText(text) {
  if (typeof text !== 'string') {
    return text
  }

  return text.replace(/\r\n?/g, '\n')
}
